module.exports = __webpack_public_path__ + "static/img/1000000534_green.e216754f.jpg";